import type { ApplePayJS } from '../../../../../types/apple-pay'
import type { PaymentRequestAddressErrors } from '../../../types/PaymentRequest'

export const mapAddressErrorsToApplePayErrors = (
  addressErrors: PaymentRequestAddressErrors,
): ApplePayJS.ApplePayError[] => {
  const errors: ApplePayJS.ApplePayError[] = []
  const {
    addressLine,
    city,
    country,
    dependentLocality,
    firstName,
    lastName,
    organization,
    phone,
    postalCode,
    region,
    sortingCode,
  } = addressErrors

  if (addressLine) {
    errors.push(
      new ApplePayError('shippingContactInvalid', 'addressLines', addressLine),
    )
  }
  if (city) {
    errors.push(new ApplePayError('shippingContactInvalid', 'locality', city))
  }
  if (country) {
    errors.push(
      new ApplePayError('shippingContactInvalid', 'countryCode', country),
    )
  }
  if (dependentLocality) {
    errors.push(
      new ApplePayError('shippingContactInvalid', undefined, dependentLocality),
    )
  }
  if (firstName) {
    errors.push(new ApplePayError('shippingContactInvalid', 'name', firstName))
  }
  if (lastName) {
    errors.push(new ApplePayError('shippingContactInvalid', 'name', lastName))
  }
  if (organization) {
    errors.push(
      new ApplePayError('shippingContactInvalid', undefined, organization),
    )
  }
  if (phone) {
    errors.push(
      new ApplePayError('shippingContactInvalid', 'phoneNumber', phone),
    )
  }
  if (postalCode) {
    errors.push(
      new ApplePayError('shippingContactInvalid', 'postalCode', postalCode),
    )
  }
  if (region) {
    errors.push(
      new ApplePayError('shippingContactInvalid', 'administrativeArea', region),
    )
  }
  if (sortingCode) {
    errors.push(
      new ApplePayError('shippingContactInvalid', undefined, sortingCode),
    )
  }

  return errors
}
